import {
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuSeparator,
} from '@ui/components/PopoverMenu/PopoverMenu';

import { UserSettingsProps } from '@features/user/hooks/useUserSettings';
import { UserMiniCard } from '@features/user/ui/UserMiniCard/UserMiniCard';

import { SiteSettingsMenuItems } from '../SiteSettingsItems/SiteSettingsMenuItems';

type Props = {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  user?: {
    firstName: string;
    lastName: string;
  };
  settings: UserSettingsProps;
  onLogout?: () => void;
  onLogin?: () => void;
};
export function UserGameMenuPopover({
  className,
  user,
  isOpen,
  onClose,
  onLogout,
  onLogin,
  settings,
}: Props) {
  return (
    <PopoverMenu className={className} isOpen={isOpen} onClose={onClose}>
      {user ? (
        <>
          <PopoverMenuItem>
            <UserMiniCard user={user} />
          </PopoverMenuItem>
        </>
      ) : (
        <br />
      )}

      {user && (
        <>
          <PopoverMenuItem href="/profile/">Личный кабинет</PopoverMenuItem>
          <PopoverMenuSeparator />
        </>
      )}
      <SiteSettingsMenuItems {...settings} />
      <PopoverMenuSeparator />
      {onLogin && <PopoverMenuItem onClick={onLogin}>Войти</PopoverMenuItem>}
      {onLogout && <PopoverMenuItem onClick={onLogout}>Выйти</PopoverMenuItem>}
    </PopoverMenu>
  );
}
